import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/sections/HeroSection';
import { SocialProofSection } from './components/sections/SocialProofSection';
import { ProblemSection } from './components/sections/ProblemSection';
import { LeverageSection } from './components/sections/LeverageSection';
import { HowItWorksSection } from './components/sections/HowItWorksSection';
import { TargetAudienceSection } from './components/sections/TargetAudienceSection';
import { TeamSection } from './components/sections/TeamSection';
import { AdvisoryBoardSection } from './components/sections/AdvisoryBoardSection';
import { FinalCTASection } from './components/sections/FinalCTASection';
import { FAQSection } from './components/sections/FAQSection';
import { FooterSection } from './components/sections/FooterSection';
import { DealflowFunnel } from './components/dealflow/DealflowFunnel';
import { ThankYou } from './components/dealflow/ThankYou';
import { BasicPage } from './components/pages/BasicPage';
import { OnboardingPage } from './components/pages/OnboardingPage';
import { OnboardingPage2 } from './components/pages/OnboardingPage2';
import { OnboardingPage3 } from './components/pages/OnboardingPage3';
import { OnboardingPage4 } from './components/pages/OnboardingPage4';
import { ApplyPage } from './components/pages/ApplyPage';
import { CalculatorPage } from './components/calculator/CalculatorPage';
import { CalculatorConfirmation } from './components/calculator/CalculatorConfirmation';
declare global {
  interface Window {
    typeform: any;
    dataLayer: any;
  }
}
const MainContent = () => {
  return <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-dark-900 to-dark-800" data-id="element-0">
      <HeroSection data-id="element-1" />
      <div className="relative" data-id="element-2">
        <div className="absolute inset-0 bg-gradient-to-b from-dark-900/50 to-transparent pointer-events-none h-32" data-id="element-3" />
        <SocialProofSection data-id="element-4" />
      </div>
      <ProblemSection data-id="element-5" />
      <LeverageSection data-id="element-6" />
      <HowItWorksSection data-id="element-7" />
      <TargetAudienceSection data-id="element-8" />
      <TeamSection data-id="element-9" />
      <AdvisoryBoardSection data-id="element-10" />
      <FinalCTASection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FooterSection data-id="element-13" />
    </div>;
};
export function App() {
  useEffect(() => {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];
    // Load Google Tag Manager script (head section)
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PMGCCDQ5');`;
    document.head.appendChild(gtmScript);
    // Add Google Tag Manager noscript iframe (body section)
    const gtmNoScript = document.createElement('noscript');
    const gtmIframe = document.createElement('iframe');
    gtmIframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-PMGCCDQ5';
    gtmIframe.height = '0';
    gtmIframe.width = '0';
    gtmIframe.style.display = 'none';
    gtmIframe.style.visibility = 'hidden';
    gtmNoScript.appendChild(gtmIframe);
    document.body.insertBefore(gtmNoScript, document.body.firstChild);
    // Load Typeform script
    const typeformScript = document.createElement('script');
    typeformScript.src = '//embed.typeform.com/next/embed.js';
    typeformScript.async = true;
    document.body.appendChild(typeformScript);
    // Load GoHighLevel form script
    const ghlFormScript = document.createElement('script');
    ghlFormScript.src = 'https://link.getdealflow.ai/js/form_embed.js';
    ghlFormScript.async = true;
    document.body.appendChild(ghlFormScript);
    return () => {
      // Clean up scripts when component unmounts
      document.head.removeChild(gtmScript);
      document.body.removeChild(gtmNoScript);
      document.body.removeChild(typeformScript);
      document.body.removeChild(ghlFormScript);
    };
  }, []);
  return <BrowserRouter data-id="element-14">
      <Routes data-id="element-15">
        <Route path="/" element={<MainContent data-id="element-17" />} data-id="element-16" />
        <Route path="/deals" element={<DealflowFunnel data-id="element-19" />} data-id="element-18" />
        <Route path="/deals/thankyou" element={<ThankYou data-id="element-21" />} data-id="element-20" />
        <Route path="/calculator" element={<CalculatorPage data-id="element-23" />} data-id="element-22" />
        <Route path="/calculator/confirmation" element={<CalculatorConfirmation data-id="element-25" />} data-id="element-24" />
        <Route path="/apply" element={<ApplyPage data-id="element-27" />} data-id="element-26" />
        <Route path="/new-page" element={<BasicPage data-id="element-29" />} data-id="element-28" />
        <Route path="/onboarding" element={<OnboardingPage data-id="element-31" />} data-id="element-30" />
        <Route path="/onboarding/step2" element={<OnboardingPage2 data-id="element-33" />} data-id="element-32" />
        <Route path="/onboarding/step3" element={<OnboardingPage3 data-id="element-35" />} data-id="element-34" />
        <Route path="/onboarding/step4" element={<OnboardingPage4 data-id="element-37" />} data-id="element-36" />
      </Routes>
    </BrowserRouter>;
}